import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
//
import enLocales from "./en.json";
import arLocales from "./ar.json";

// ----------------------------------------------------------------------

// Sync ?lang=ar / ?lang=en from URL into localStorage so both i18n and
// themeDirection (SettingsContext) pick it up before React mounts.
const urlLang = new URLSearchParams(window.location.search).get("lang");
if (urlLang === "ar" || urlLang === "en") {
  localStorage.setItem("i18nextLng", urlLang);
  try {
    const stored = JSON.parse(localStorage.getItem("settings") || "{}");
    localStorage.setItem(
      "settings",
      JSON.stringify({
        ...stored,
        themeDirection: urlLang === "ar" ? "rtl" : "ltr",
      }),
    );
  } catch (_) {}
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      ar: { translations: arLocales },
    },
    lng: localStorage.getItem("i18nextLng") || "ar",
    fallbackLng: "ar",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
